/**
 * Which deposit (if any) to show a customer on the public booking page.
 *
 * Mirrors the API rule in apps/api/src/lib/booking-deposit.ts:
 * - no deposit messaging at all when the shop cannot take card payments
 *   (deposits are only ever charged online);
 * - a deposit of 0, or one equal to / above the price, is not a deposit:
 *   the customer pays the full price, so no "deposit" wording.
 */
export function displayDepositCents(
  depositCents: number | null | undefined,
  priceCents: number | null | undefined,
  acceptsPayments: boolean | null | undefined
): number | null {
  if (!acceptsPayments) return null;
  if (depositCents == null || !Number.isFinite(depositCents) || depositCents <= 0) return null;
  if (priceCents == null || !Number.isFinite(priceCents) || priceCents <= 0) return null;
  if (depositCents >= priceCents) return null;
  return Math.round(depositCents);
}

export function formatPounds(cents: number): string {
  return `£${(cents / 100).toFixed(2)}`;
}
